import "./App.css";
import { useEffect, useState } from "react";
import { auth, db } from "./firebaseconfig";
import Login, { authorizedEmails } from "./Login";
import { onAuthStateChanged } from "firebase/auth";
import { collection, doc, getDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
} from "recharts";

function TrackingPage() {
  const [user, setUser] = useState();
  const [trackingData, setTrackingData] = useState();
  const { id } = useParams();

  onAuthStateChanged(auth, (user) => {
    setUser(user);
  });

  useEffect(() => {
    if (user) {
      const docRef = doc(collection(db, "tracking"), id.toLowerCase());
      const getTrackingData = async () => {
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          console.log(docSnap.data());
          setTrackingData(docSnap.data());
        }
      };
      getTrackingData();
    }
  }, [id, user]);

  if (!user || !authorizedEmails.includes(user.email)) {
    return <Login />;
  }

  const chartData = trackingData?.visits.reduce((acc, visit) => {
    const date = new Date(visit.timestamp).toLocaleDateString();
    const existingEntry = acc.find((entry) => entry.name === date);
    if (existingEntry) {
      existingEntry.visits += 1;
    } else {
      acc.push({ name: date, visits: 1 });
    }
    return acc;
  }, []);

  const utmData = trackingData?.visits.reduce((acc, visit) => {
    if (visit.utm && !acc[visit.utm]) {
      acc[visit.utm] = { name: visit.utm, value: 0 };
    }
    if (visit.utm) {
      acc[visit.utm].value += 1;
    }
    return acc;
  }, {});

  const languageData = trackingData?.visits.reduce((acc, visit) => {
    if (!acc[visit.language]) {
      acc[visit.language] = { name: visit.language, value: 0 };
    }
    acc[visit.language].value += 1;
    return acc;
  }, {});

  return (
    <div className="container">
      <h1 className="title">URL Tracking</h1>
      <p>/{id}</p>
      <div className="content">
        <div className="data-table">
          <table>{/* Table content remains the same */}</table>
        </div>
        {trackingData ? (
          <div className="charts-container">
            <div className="chart-item">
              <h2>Visits Over Time</h2>
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={chartData}>
                  <XAxis dataKey="name" />
                  <YAxis />
                  <CartesianGrid strokeDasharray="3 3" />
                  <Tooltip />
                  <Legend />
                  <Line
                    type="monotone"
                    dataKey="visits"
                    stroke="#8884d8"
                    strokeWidth={3}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
            <div className="chart-item">
              <h2>UTM Breakdown</h2>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={Object.values(utmData)}>
                  <XAxis dataKey="name" />
                  <YAxis />
                  <CartesianGrid strokeDasharray="3 3" />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="value" fill="#8884d8" />
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="chart-item">
              <h2>Language Breakdown</h2>
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={Object.values(languageData)}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={80}
                  >
                    {Object.values(languageData).map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={
                          ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"][
                            index % 4
                          ]
                        }
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
        ) : (
          <p>No activity yet...</p>
        )}
      </div>
    </div>
  );
}

export default TrackingPage;
